import axios from "axios";
import NProgress from "nprogress";

import store from "../../store/store";
import RouterUtils from "../../utils/BaseUtils/RouterUtils";

const apiClient = axios.create({
  baseURL: window.__env.api.baseUrl,
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  },
  timeout: 10000
});

apiClient.interceptors.request.use(config => {
  const token = store.getters["user/getUserTokenFromLocalStorage"];
  if (token != null) {
    config.headers.Authorization = token;
  }
  return config;
});
apiClient.interceptors.response.use(response => {
  NProgress.done();
  if (response.data.responseCode === "92") {
    RouterUtils.changeRouteTo("login");
  }
  return response;
});

export default {
  uploadBankLogo(requestBody) {
    return apiClient.post("/bankUpdateLogo", JSON.stringify(requestBody));
  },
  fetchBankStatsData(requestBody) {
    return apiClient.post("/bankRead", JSON.stringify(requestBody));
  },
  allBanks(requestBody) {
    return apiClient.post("/bankRead", JSON.stringify(requestBody));
  },
  createBank(requestBody) {
    return apiClient.post("/bankcreate", JSON.stringify(requestBody));
  },
  editBank(requestBody) {
    return apiClient.post("/bankUpdate", JSON.stringify(requestBody));
  },
  singleBank(requestBody) {
    return apiClient.post("/bankReadSingle", JSON.stringify(requestBody));
  }
};
